import { useState } from "react";
import { Link } from "react-router-dom";
import Drower from "./Drower";

function Login() {
  const [visibleContact, setVisibleContact] = useState(false)


  return (
    <>
      <div className="login">
        <Link to='/calucator'>
          <div className="login-btn1" >
            {localStorage.getItem('language') == 'fa' ? 'شروع' : 'Start'}
          </div>
        </Link>
        <div className="login-btn2" onClick={() => { setVisibleContact(true) }} >
          {localStorage.getItem('language') == 'fa' ? 'ارتباط با ما' : 'Contact us'}
        </div>
      </div>
      <Drower name={localStorage.getItem('language') == 'fa' ? 'ارتباط با ما' : 'Contact us'} title={'show-p-contact'} visible={visibleContact} setVisible={setVisibleContact}>
        <div className="contact">
          <a href="https://hamedpeiravi.com" target={'_blank'}>
            <div className="contact-item">
              <svg x="0px" y="0px" viewBox="0 0 17 17" >
                <use xlinkHref="/assets/svg/world.svg#world" />
              </svg>
              <span>www.hamedpeiravi.com</span>
            </div>
          </a>
          <a href="https://instagram.com/hamed_peiravi" target={'_blank'}>
            <div className="contact-item">
              <svg x="0px" y="0px" viewBox="0 0 32 32" >
                <use xlinkHref="/assets/svg/instagram.svg#instagram" />
              </svg>
              <span>@hamed_peiravi</span>
            </div>
          </a>
          <div className="drower-close" onClick={() => { setVisibleContact(false) }}>
            {localStorage.getItem('language') == 'fa' ? 'بستن' : 'Close'}
          </div>
        </div>
      </Drower>
    </>
  );
}

export default Login;